/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Gallery, { type GalleryProps } from 'components/Gallery/Gallery';
import './ImageGallery.scss';

interface ImageGalleryProps extends GalleryProps {
  heading?: string;
}

/**
 * This is the ImageGallery component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function ImageGallery({ heading = '', ...props }: ImageGalleryProps) {
  function renderHeading() {
    if (!heading) return null;

    return <h2>{heading}</h2>;
  }

  return (
    <div className="block image-gallery" appear="true">
      {renderHeading()}
      <Gallery heading={heading} {...props} />
    </div>
  );
}

export default ImageGallery;
